function replaceGoogleFonts(html)
{
	html = html.replace(/<link rel="stylesheet" href="https:\/\/fonts\.googleapis\.com[^>]+>/g, '');

	/*var fontCss = `<style type="text/css">
	 @font-face {
	 font-family: 'Roboto';
	 font-style: normal;
	 font-weight: 300;
	 src: url(https://fonts.gstatic.com/s/roboto/v15/Hgo13k-tfSpn0qi1SFdUfSZ2oysoEQEeKwjgmXLRnTc.ttf) format('truetype');
	 }
	 @font-face {
	 font-family: 'Roboto';
	 font-style: normal;
	 font-weight: 700;
	 src: url(https://fonts.gstatic.com/s/roboto/v15/d-6IYplOFocCacKzxwXSOCZ2oysoEQEeKwjgmXLRnTc.ttf) format('truetype');
	 }
	 @font-face {
	 font-family: 'Roboto';
	 font-style: italic;
	 font-weight: 300;
	 src: url(https://fonts.gstatic.com/s/roboto/v15/7m8l7TlFO-S3VkhHuR0atywlidHJgAgmTjOEEzwu1L8.ttf) format('truetype');
	 }
	 @font-face {
	 font-family: 'Roboto';
	 font-style: italic;
	 font-weight: 700;
	 src: url(https://fonts.gstatic.com/s/roboto/v15/t6Nd4cfPRhZP44Q5QAjcCywlidHJgAgmTjOEEzwu1L8.ttf) format('truetype');
	 }
	 @font-face {
	 font-family: 'Roboto Condensed';
	 font-style: normal;
	 font-weight: 400;
	 src: url(https://fonts.gstatic.com/s/robotocondensed/v13/Zd2E9abXLFGSr9G3YK2MsMEHkXu385rSv8spHqOuvSI.ttf) format('truetype');
	 }
	 @font-face {
	 font-family: 'Roboto Condensed';
	 font-style: normal;
	 font-weight: 700;
	 src: url(https://fonts.gstatic.com/s/robotocondensed/v13/b9QBgL0iMZfDSpmcXcE8nPVE82mBoqAQeMZO1WdebIw.ttf) format('truetype');
	 }
	 </style>`;

	 return html.replace(/<head>/, '<head>'+fontCss);*/

	return html;
}

function copyPieCharts(html)
{
	var pieChartIds = ['male-gender-pie-chart', 'female-gender-pie-chart', 'item-stats-votes-pie-chart'];

	for (var i = 0; i < pieChartIds.length; i++)
	{
		var exportChart = (html.indexOf(pieChartIds[i]) != -1 ? true : false);
		var localChart = $('#' + pieChartIds[i]);
		if (exportChart && localChart.length)
		{
			html = html.replace(new RegExp('(<div[^>]*id\\s*=\\s*"' + pieChartIds[i] + '"[^>]*>)\\s*</div>'),
			function (match, p1)
			{
				return p1.replace(/class="/, 'class="done ') + localChart.html() + '</div>';
			});
		}
	}

	return html;
}

function cleanExportHTML(html)
{
	if (!window.export)
		html = copyPieCharts(html);

	//return html;

	return replaceGoogleFonts(html);
}

function getExportHTML()
{
	if (window.export)
	{
		return $.Deferred(function (deferred)
		{
			var getDocTypeAsString = function ()
			{
				var node = document.doctype;
				return node ? "<!DOCTYPE "
				+ node.name
				+ (node.publicId ? ' PUBLIC "' + node.publicId + '"' : '')
				+ (!node.publicId && node.systemId ? ' SYSTEM' : '')
				+ (node.systemId ? ' "' + node.systemId + '"' : '')
				+ '>\n' : '';
			};

			var body = $('body');
			var backdrop = $('.modal-backdrop,#export-modal');

			var backdropDisplay = backdrop.css('display');
			backdrop.css('display', 'none');
			var hasModalOpen = body.hasClass('modal-open');
			body.removeClass('modal-open');

			var audienceAffinity = $('.audience-affinity.export-selected');

			if (audienceAffinity.length)
			{
				if (audienceAffinity.find('.export-selected').length == 0)
				{
          window.export.toggleExportSelectCheckbox(audienceAffinity);
          audienceAffinity.removeClass('export-selected');
        }
				else
				{
					var audienceBackup = $('.audience-affinity').html();

					$('.audience-affinity').find('.export-selectable:not(.export-selected)').remove();
				}
			}

			var listRowBackups = {};

			var firstListRow = true;

			$('.list-col.export-selected').each(function ()
			{
				var that = $(this);

				var numSelected = that.find('.export-selected').length;
				if (numSelected == 0)
				{
					window.export.toggleExportSelectCheckbox(that);
					that.removeClass('export-selected');
					return;
				}

				listRowBackups[that.attr('id')] = that.html();

        window.wrapExportSelected(true, that); //rewrap everything with the list-row-wrapper's

        if (numSelected > 40)
				{
					var breakRowIndex = 0;
					var numListRows = 0;
					var listColChildren = that.children();

					var rowsUntilBreak = (body.hasClass('has-demographic-breakdown') ||
					body.hasClass('has-rankings') ||
					body.hasClass('has-audience-affinity') ? 10 : 2);

					listColChildren.each(function (index)
					{
						if (breakRowIndex)
							return false;

						if ($(this).is('.list-row-wrapper'))
							numListRows++;

						if (numListRows == rowsUntilBreak + 1)
						{
							breakRowIndex = index;
							return false;
						}
					});

					listColChildren.slice(0, breakRowIndex).wrapAll('<div class="export-unbreakable"></div>');
					listColChildren.slice(breakRowIndex).wrapAll('<div class="export-unbreakable"></div>');

					that.addClass('export-breakable');
				}
				else
					that.removeClass('export-breakable');


				that.find('.export-selectable:not(.export-selected)').remove();

				firstListRow = false;
			});

			if (body.hasClass('has-demographic-breakdown') || body.hasClass('has-audience-affinity') || body.hasClass('has-rankings'))
			{
				var pageGroup;
				if (body.hasClass('has-demographic-breakdown') || body.hasClass('has-rankings'))
				{
					pageGroup = $('.header-container').nextUntil('.demographics-and-rankings-outer').andSelf().add(
					'.demographics-and-rankings-outer');
				}
				else if (body.hasClass('has-audience-affinity'))
				{
					pageGroup = $('.header-container').nextUntil('#audience-affinity').andSelf().add(
					'#audience-affinity');
				}

				pageGroup.wrapAll('<div class="vertical-center export-page"><div></div></div>')
			}

			//window.export.makeFourColumns();
			setRowHeights();
			window.export.wrapAudienceAffinity();

			var html = getDocTypeAsString() + document.documentElement.outerHTML;
			html = html.replace(/target="_blank"/g, '');

			if (pageGroup)
				pageGroup.unwrap().unwrap();

      window.wrapExportSelected(false); //unwrap all the list rows
      setRowHeights();

      $('.list-col.export-selected').each(function ()
			{
				var that = $(this);
				const groupHeaderBackup = that.find('.group-header');
				that.html(listRowBackups[that.attr('id')]);
				that.find('.group-header').html(groupHeaderBackup);
			});

			if (audienceAffinity.length)
			{
				$('.audience-affinity').html(audienceBackup);
			}

			backdrop.css('display', backdropDisplay);
			if (hasModalOpen)
				body.addClass('modal-open');


			deferred.resolve(cleanExportHTML(html));
		});
	}
	else
	{
		return $.ajax({
			url: window.location + '&export=1&howto=0'
		})
		.then(function (data)
		{
			return $.Deferred(function (deferred)
			{
				if (!data)
				{
					deferred.reject('no data returned');
				}

				data = data.replace(/export-selectable/g, '');

				deferred.resolve(cleanExportHTML(data));
			});
		});
	}
}

window.getExportHTML = getExportHTML;


/**
 * Organizes the list-row-wrappers so that the selected items always are 4 per row
 * @param wrap if true, then 4 per row for export selected items, otherwise 4 per row of any items
 */
function wrapExportSelected(wrap, listCol)
{
	if(!listCol)
		listCol = $('.list-col');

	listCol
	.each(function ()
	{
		var that = $(this);
		that.find('.list-row-wrapper').children().unwrap();

		var items = that.find('.list-row');
		var numSliceItems = 0;
		var sliceStart = 0;
		for (var i = 0; i < items.length; i += 1)
		{
			if(!wrap || $(items[i]).is('.export-selected')) {
				numSliceItems++;
			}
			if(numSliceItems === 4) {
				numSliceItems = 0;
        items.slice(sliceStart, i + 1)
        .nextUntil('.list-row') // select the row spacers after the item
        .andSelf() //select the item again
        .wrapAll('<div class="list-row-wrapper clearfix"></div>');

        sliceStart = i+1;
      }
		}

		if(sliceStart < items.length) {
      items.slice(sliceStart, i)
      .nextUntil('.list-row') // select the row spacers after the item
      .andSelf()
      .wrapAll('<div class="list-row-wrapper clearfix"></div>');
		}
	});

	$('.node-score').css('margin-top', '');
}

window.wrapExportSelected = wrapExportSelected;